import * as Yup from "yup";
import { RequirementDefinitionTemplateForm } from "../../types";
import { FormPartialAcceptWingspanMasterPolicy } from "../FormPartialAcceptWingspanMasterPolicy";
import { WarningWingspanIsNotAgent } from "../WarningWingspanIsNotAgent";
import {
  FormPartialGeneralLiability,
  GENERAL_LIABILITY_AGGREGATE_MINIMUM_COMMON,
  GENERAL_LIABILITY_PER_OCCURRENCE_MINIMUM_COMMON
} from "../FormPartialGeneralLiability";
import { CreateRequirementDefinitionInsuranceCoveragePartialForm } from "../../../../modules/InsuranceCoverage/createRequirementDefinition/types";

type GeneralLiabilityValues = {
  acceptWingspanMasterPolicy: boolean;
  coverageType: "occurrence" | "claimsMade";
  perIncidentLimitMinimum: string;
  totalCoverageLimitMinimum: string;
};

/*
https://github.com/wingspanHQ/benefits/blob/staging/src/lib/interfaces/insuranceRequirement.ts
*/

export const GENERAL_LIABILITY_FORM: RequirementDefinitionTemplateForm<
  GeneralLiabilityValues,
  CreateRequirementDefinitionInsuranceCoveragePartialForm
> = {
  getDefaultValues: template => ({
    name: template.name,
    acceptWingspanMasterPolicy: true,
    coverageType: "occurrence",
    perIncidentLimitMinimum: `${GENERAL_LIABILITY_PER_OCCURRENCE_MINIMUM_COMMON}`,
    totalCoverageLimitMinimum: `${GENERAL_LIABILITY_AGGREGATE_MINIMUM_COMMON}`
  }),
  mapFormData(values) {
    const {
      acceptWingspanMasterPolicy,
      totalCoverageLimitMinimum,
      perIncidentLimitMinimum,
      coverageType,
      ...other
    } = values;

    return {
      ...other,
      coverages: [
        {
          policyType: "GeneralLiability",
          appliedProvisions: [],
          limits: [
            {
              limitType: "PerAccident",
              amount: Number(perIncidentLimitMinimum),
              currency: "USD"
            },
            {
              limitType: "PolicyAggregate",
              amount: Number(totalCoverageLimitMinimum),
              currency: "USD"
            }
          ],
          acceptedSourceTypes: acceptWingspanMasterPolicy
            ? ["InsuranceImport", "PlanEnrollment"]
            : ["InsuranceImport"],
          coverageForm:
            coverageType === "claimsMade" ? "ClaimsMade" : "Occurrence"
        }
      ]
    };
  },
  partialForm: (
    <>
      <WarningWingspanIsNotAgent />
      <FormPartialAcceptWingspanMasterPolicy switchLabel="Accept Wingspan's PL/GL Master Policy" />
      <FormPartialGeneralLiability />
    </>
  ),
  validationSchema: Yup.object().shape({
    acceptWingspanMasterPolicy: Yup.boolean().required("Required"),
    coverageType: Yup.string()
      .oneOf(["occurrence", "claimsMade"])
      .required("Required") as Yup.AnySchema,
    perIncidentLimitMinimum: Yup.string().required("Required"),
    totalCoverageLimitMinimum: Yup.string().required("Required")
  })
};
